import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, BookOpen, Newspaper, FileText, Award } from 'lucide-react';

const publicationsData = [
  {
    id: 1,
    title: "The Future of Cross-Continental Infrastructure Networks",
    source: "Engineering News-Record",
    year: "2023",
    description: "An in-depth analysis of emerging trends in international infrastructure development, examining how digital twins and cross-border collaboration are reshaping the industry.",
    logo: "ENR",
    link: "/articles/cross-continental-infrastructure"
  },
  {
    id: 2,
    title: "Generational Thinking in Civil Engineering",
    source: "ASCE Civil Engineering Magazine",
    year: "2022",
    description: "Wargner's influential piece on designing infrastructure with 100-year horizons, challenging engineers to consider lifecycle impacts beyond standard design specifications.",
    logo: "ASCE",
    link: "/articles/generational-thinking"
  },
  {
    id: 3,
    title: "Bridging Cultures: European Innovation in American Infrastructure",
    source: "Construction Dive",
    year: "2021",
    description: "Interview feature exploring how Czech engineering traditions and European regulatory frameworks are influencing modern American infrastructure projects.",
    logo: "CD",
    link: "/articles/bridging-cultures"
  },
  {
    id: 4,
    title: "Featured Recognition: Infrastructure Leaders Review",
    source: "Infrastructure Leaders Review",
    year: "2023",
    description: "Cover feature recognizing Ruben P. Wargner as a Global Infrastructure Visionary for his cross-continental leadership and transformative impact.",
    logo: "ILR",
    link: "/articles/featured-recognition"
  }
];

const LogoIcon = ({ logo }) => {
  switch(logo) {
    case 'ENR': return <Newspaper size={32} />;
    case 'ASCE': return <BookOpen size={32} />;
    case 'ILR': return <Award size={32} />;
    default: return <FileText size={32} />;
  }
};

const PublicationCard = ({ publication }) => {
  return (
    <div className="publication-card">
      <div className="publication-logo">
        <LogoIcon logo={publication.logo} />
        <span className="logo-text">{publication.logo}</span>
      </div>
      <div className="publication-content">
        <div className="publication-meta">
          <span className="publication-source">{publication.source}</span>
          <span className="publication-year">{publication.year}</span>
        </div>
        <h3 className="publication-title">{publication.title}</h3>
        <p className="publication-description">{publication.description}</p>
        <Link to={publication.link} className="publication-link">
          Read More <ExternalLink size={14} />
        </Link>
      </div>
    </div>
  );
};

const Publications = () => {
  return (
    <section id="publications" className="publications-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Media</span>
          <h2 className="heading-2">Publications & Features</h2>
          <p className="section-subtitle">Thought leadership in industry-leading publications</p>
        </div>
        
        <div className="publications-grid">
          {publicationsData.map((publication) => (
            <PublicationCard key={publication.id} publication={publication} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
